import React from 'react';
import {useNavigate} from 'react-router-dom';
import {Button} from "../components";

const NotFound = () => {
    const navigate = useNavigate();

    const goToHome = () => {
        navigate('/');
    };

    return (
        <section className="mt-60 flex justify-center items-center">
            <div className="notfound flex items-center flex-col">
                <div className="notfound-404">
                    <h3>الصفحة غير موجودة</h3>
                    <h1 style={{ color: 'rgb(185, 28, 28)' }}>
                        <span>4</span>
                        <span>0</span>
                        <span>4</span>
                    </h1>
                </div>
                <h2>عذراً، الصفحة التي تبحث عنها غير موجودة.</h2>
                <Button className="rounded-[10px] hidden md:flex"
                   icon={true}
                    onClick={goToHome}
                >
                    العودة إلى الصفحة الرئيسية
                </Button>
            </div>
        </section>

    );
};

export default NotFound;
